<template lang="pug">
  .row(v-if="gmapLoaded")
    .col-md-12
      GmapMap(ref="map" :center="center" :markers="markers" :zoom="2" style="height: 500px;")
        GmapMarker(:key="marker" v-for="(m, marker) in markers" :position="m" @click="openInfoWindow(m)")
        GmapInfoWindow(:options="infoOptions" :position="infoWindowPos" :opened="infoWindowOpen" :content="infoContent" @closeclick="infoWindowOpen=false")
</template>

<script>
import TrackNTrace from '@/service/apis/TrackNTrace'
import GmapLazy from '@/utils/GmapLazy'

export default {
  props: ['filter'],
  data: () => ({
    gmapLoaded: false,
    markers: [],
    infoWindowOpen: false,
    locationId: null,
    infoWindowPos: { lat: 0, lng: 0 },
    infoContent: '',
    infoOptions: {
      pixelOffset: {
        width: 0,
        height: -35
      }
    }
  }),
  methods: {
    onGmapLoaded() {
      this.gmapLoaded = true
      TrackNTrace.getEventCount({ endDate: this.filter.endDate, startDate: this.filter.startDate })
        .then((resp) => {
          const markers = resp.data.map((m) => {
            const marker = {
              lat: m.location.coordinates.lat,
              lng: m.location.coordinates.lng,
              id: m.location.id,
              name: m.location.name,
              events: m.count
            }
            return marker
          })
          this.markers = markers
        })
    },
    openInfoWindow(marker) {
      this.infoWindowPos = { lat: marker.lat, lng: marker.lng }
      this.infoContent = `<b><a href="#/trackntrace/dashboards/locationportal/${marker.id}/packagetype">${marker.name}</a></b>, ${marker.events}`
      this.infoWindowOpen = true
    }
  },
  watch: {
    filter: {
      handler() {
        this.onGmapLoaded()
      },
      deep: true
    }
  },
  computed: {
    center() {
      return { lat: 0, lng: 0 }
    }
  },
  mounted() {
    GmapLazy.loadGmap()
      .then(this.onGmapLoaded)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/components/TrackingMap.vue